import React from 'react'
import { createRoot } from 'react-dom/client'
import App from '../vocare/components/App'

import './application.css'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('vocare-root')
  if (container) {
    const root = createRoot(container)
    root.render(<App />)
  }
})
